import { Navigate, useLocation } from "react-router-dom";
import type { Permission } from "@edufadder/shared-types";
import { useAuth } from "../lib/auth-context.js";
import * as s from "../styles.js";

export function RequireAuth({ children, permission }: { children: JSX.Element; permission?: Permission }): JSX.Element {
  const { me, loading, hasPermission } = useAuth();
  const location = useLocation();

  if (loading) return <div style={s.container}>Loading…</div>;
  if (!me) return <Navigate to="/login" state={{ from: location }} replace />;
  if (permission && !hasPermission(permission)) {
    return (
      <div style={s.container}>
        <h1 style={s.heading1}>Not available</h1>
        <p style={s.mutedText}>Your account doesn't have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
